"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var design_system_variables_1 = require("../variables/design-system-variables");
var default_theme_1 = __importDefault(require("./default-theme"));
var design_system_colors_1 = require("./design-system-colors");
var designSystemTheme = __assign(__assign({ name: 'design-system' }, default_theme_1.default), { global: __assign(__assign({}, default_theme_1.default.global), { '*': {
            fontFamily: 'Inter, sans-serif',
            boxSizing: 'border-box',
            lineHeight: 1.5,
            '&::-webkit-scrollbar': {
                width: 14,
                height: 14,
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
            },
            ':hover': {
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: 7,
                    background: design_system_colors_1.DesignSystemThemeColor.Gray.LIGHT_3,
                    border: '3px solid transparent',
                    backgroundClip: 'padding-box',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: design_system_colors_1.DesignSystemThemeColor.Gray.LIGHT_1,
                    border: '2px solid transparent',
                    backgroundClip: 'padding-box',
                },
            },
            ':root': __assign({}, design_system_variables_1.DESIGN_SYSTEM_VARIABLES),
        } }), color: __assign(__assign({}, default_theme_1.default.color), { PRIMARY: design_system_colors_1.DesignSystemThemeColor.Primary, GRAY: design_system_colors_1.DesignSystemThemeColor.Gray, ERROR: design_system_colors_1.DesignSystemThemeColor.Error, WARNING: design_system_colors_1.DesignSystemThemeColor.Warning, SUCCESS: design_system_colors_1.DesignSystemThemeColor.Success }), border: "1px solid " + design_system_colors_1.DesignSystemThemeColor.Gray.LIGHT_3 });
exports.default = designSystemTheme;
